import { AfterViewInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AccessComponent } from '../../../../pages/access-module/access.component';
import { ChubbFooterComponent } from '../chubb-footer/chubb-footer.component';
// import * as $ from 'jquery';
// import { DownTo, UpTo } from '../../../../../assets/js/utils/utils.js';
@Component({
    selector: 'app-main',
    imports: [HeaderComponent, SidebarComponent, BreadcrumbComponent, ChubbFooterComponent, RouterOutlet, RouterLink, RouterLinkActive, AccessComponent],
    templateUrl: './main.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './main.component.scss'
})
export class MainComponent implements OnInit, AfterViewInit {

  constructor() {
  }
  ngAfterViewInit(): void {

  }

  ngOnInit() {

  }

}
